var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconPom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 32H12.3C4.92002 32 0 27.08 0 19.7V0H19.69C27.07 0 31.99 4.92 31.99 12.3V32H32Z",
    fill: "#004E2B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.22 11.0699H19.68C24.27 11.0699 27.06 13.8699 27.06 18.4499V27.0599H24.6C20.07 27.0599 17.22 24.1699 17.22 19.6799V11.0699Z",
    fill: "#00DD39"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.92001 4.92004H14.76V27.07H12.3C7.73002 27.07 4.92001 24.3 4.92001 19.69V4.92004Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPom);
export default __webpack_public_path__ + "static/media/IconPom.6fd8a1cdef601a9f4f39b68ebf336f47.svg";
export { ForwardRef as ReactComponent };